import * as React from "react"

import { Button, type ButtonProps } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export interface IconButtonProps
  extends Omit<ButtonProps, "size" | "children"> {
  icon: React.ReactNode
  /** Accessible name — required since an icon-only button has no visible text. */
  label: string
  size?: "sm" | "md" | "lg"
}

const ICON_BUTTON_SIZE_CLASSES: Record<NonNullable<IconButtonProps["size"]>, string> = {
  sm: "h-7 w-7",
  md: "h-9 w-9",
  lg: "h-10 w-10",
}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, label, size = "md", className, variant = "ghost", ...props }, ref) => (
    <Button
      ref={ref}
      variant={variant}
      size="icon"
      aria-label={label}
      title={label}
      className={cn(ICON_BUTTON_SIZE_CLASSES[size], className)}
      {...props}
    >
      {icon}
    </Button>
  )
)
IconButton.displayName = "IconButton"

export { IconButton }
